import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, of, Observable } from 'rxjs';
import { UserService } from '../user.service';

@Injectable({
    providedIn: 'root'
})
export class MockFamilyService {
    private userService = inject(UserService);

    private mockFamily = {
        id: 'mock-family-id',
        name: 'Mock Family',
        members: ['test-user-id']
    };

    private currentFamilySubject: BehaviorSubject<any>;
    currentFamily$: Observable<any>;

    private families: any[] = [this.mockFamily];
    private readonly STORAGE_KEY = 'mock_families';

    constructor() {
        // Load initial data
        const stored = localStorage.getItem(this.STORAGE_KEY);
        if (stored) {
            this.families = JSON.parse(stored);
        }

        // Find current family from user
        const user = this.userService.currentProfileSnapshot;
        const currentFam = this.families.find(f => f.id === user?.familyId) || this.mockFamily;
        this.currentFamilySubject = new BehaviorSubject<any>(currentFam);
        this.currentFamily$ = this.currentFamilySubject.asObservable();
    }

    private saveToStorage() {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.families));
    }

    async createFamily(name: string, ownerId: string) {
        const newFamily = {
            id: 'mock-family-' + Date.now(),
            name,
            ownerId,
            members: [ownerId]
        };
        this.families.push(newFamily);
        this.saveToStorage();
        this.currentFamilySubject.next(newFamily);
        return Promise.resolve(newFamily.id);
    }

    async getFamiliesForUser(uid: string) {
        return Promise.resolve(this.families.filter(f => f.members.includes(uid)));
    }

    async switchFamily(familyId: string) {
        const fam = this.families.find(f => f.id === familyId);
        if (fam) {
            const user = this.userService.currentProfileSnapshot;
            if (user) {
                await this.userService.updateFamilyId(user.uid, familyId);
            }
            this.currentFamilySubject.next(fam);
        }
        return Promise.resolve();
    }

    async loadFamily(familyId: string) {
        const fam = this.families.find(f => f.id === familyId);
        if (fam) {
            this.currentFamilySubject.next(fam);
        }
        return Promise.resolve();
    }

    async addMemberByEmail(email: string) {
        const current = this.currentFamilySubject.value;
        if (current) {
            current.members.push('new-member-id');
            this.currentFamilySubject.next({ ...current });
        }
        return Promise.resolve();
    }

    async inviteMember(email: string) {
        return Promise.resolve();
    }

    async removeMember(userId: string) {
        const current = this.currentFamilySubject.value;
        if (current) {
            current.members = current.members.filter((m: string) => m !== userId);
            this.currentFamilySubject.next({ ...current });
        }
        return Promise.resolve();
    }
}
